export const getCartItemUnitPrice = (item) => {
  const variantPrice = Number(item?.variantPrice);
  if (variantPrice && variantPrice !== 0) {
    return variantPrice;
  }
  return Number(item?.productPrice || 0);
};

export const getCartItemLineTotal = (item) =>
  getCartItemUnitPrice(item) * Number(item?.productQuantity || 0);

export const getCartSubtotal = (items = []) =>
  items.reduce((sum, item) => sum + getCartItemLineTotal(item), 0);
